import styled from 'styled-components'

import { getResizedImageUrl } from '@/utils/image-resizer/imageResizer'

export interface Props {
  className?: string
  nickname: string
  profileUrl: string
  level: string
  description?: string | React.ReactNode
  onClick?: (e: React.MouseEvent) => void
}

const UserProfile = ({ className, nickname, profileUrl, level, description, onClick }: Props): JSX.Element => {
  return (
    <StyledContainer className={className} onClick={onClick}>
      <StyledProfileWrapper>
        <StyledProfileImg
          src={getResizedImageUrl(profileUrl, { width: 40, height: 40 })}
          width={40}
          height={40}
          alt={nickname}
        />
      </StyledProfileWrapper>
      <StyledContent>
        <StyledName>
          {nickname}
          <StyeldLevel>Lv.{level}</StyeldLevel>
        </StyledName>
        <StyledDescription>{description}</StyledDescription>
      </StyledContent>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`
const StyledProfileWrapper = styled.div`
  margin-right: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const StyledProfileImg = styled.img`
  border-radius: 38px;
  overflow: hidden;
`
const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const StyledName = styled.h3`
  margin: 0;
  ${({ theme }) => theme.typography.title4};
`
const StyeldLevel = styled.span`
  ${({ theme }) => theme.typography.title4}
  color: ${({ theme }) => theme.colors.gray700};
  margin-left: 4px;
`
const StyledDescription = styled.div`
  margin: 0;
  margin-top: 4px;
  ${({ theme }) => theme.typography.caption2};
  color: ${({ theme }) => theme.colors.gray800};
`

export default UserProfile
